import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    eventDate: {
      validations: [
        { type: 'required', message: 'Please select a date for your event' },
        { type: 'dateinfuture', message: 'Preferred event date must be in the future' }
      ]
    },
    StartTime: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    }, 
    EndTime: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    plannedguestcount: {
      validations: [
        { type: 'required', message: 'Please enter the number of guests' }
      ]
    },
    theme: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    firstName: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    lastName: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    email: {
      validations: [
        { type: 'required', message: 'Please provide an email' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email' }
      ]
    },
    telnumber: {
      validations: [
        { type: 'required', message: 'Please provide a telephone number' },
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number' }
      ] 
    },
    Reference: {
      validations: []  
    },
    notes: {
      validations: []
    },
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'Event Date:*',
            mapping: 'eventDate'
          },
        ]
       },
       {
        fields: [
          {
             type: 'multiple-choice',
             size: 'Medium',
             label: 'Event Start Time:*',
             options: [
               { label: '7:30 AM', value: '07:30:00' },
               { label: '8:00 AM', value: '08:00:00' },
               { label: '8:30 AM', value: '08:30:00' },
               { label: '9:00 AM', value: '09:00:00' },
               { label: '9:30 AM', value: '09:30:00' },
               { label: '10:00 AM', value: '10:00:00' },
               { label: '10:30 AM', value: '10:30:00' },
               { label: '11:00 AM', value: '11:00:00' },
               { label: '11:30 AM', value: '11:30:00' },
               { label: '12:00 PM', value: '12:00:00' },
               { label: '12:30 PM', value: '12:30:00' },
               { label: '1:00 PM', value: '13:00:00' },
               { label: '1:30 PM', value: '13:30:00' },
               { label: '2:00 PM', value: '14:00:00' },
               { label: '2:30 PM', value: '14:30:00' },
               { label: '3:00 PM', value: '15:00:00' },
               { label: '3:30 PM', value: '15:30:00' },
               { label: '4:00 PM', value: '16:00:00' },
               { label: '4:30 PM', value: '16:30:00' },
               { label: '5:00 PM', value: '17:00:00' },
               { label: '5:30 PM', value: '17:30:00' },
               { label: '6:00 PM', value: '18:00:00' },
               { label: '6:30 PM', value: '18:30:00' },
               { label: '7:00 PM', value: '19:00:00' },
               { label: '7:30 PM', value: '19:30:00' },
               { label: '8:00 PM', value: '20:00:00' },
               { label: '8:30 PM', value: '20:30:00' },
               { label: '9:00 PM', value: '21:00:00' },
               { label: '9:30 PM', value: '21:30:00' },
               { label: '10:00 PM', value: '22:00:00' },
               { label: '10:30 PM', value: '22:30:00' },
               { label: '11:00 PM', value: '23:00:00' },
               { label: '11:30 PM', value: '23:30:00' },
               { label: '12:00 AM (next day)', value: '00:00:00' },
               { label: '12:30 AM (next day)', value: '00:30:00' },
               { label: '1:00 AM (next day)', value: '01:00:00' },
               { label: '1:30 AM (next day)', value: '01:30:00' },
               { label: '2:00 AM (next day)', value: '02:00:00' },
               { label: '2:30 AM (next day)', value: '02:30:00' }
             ],
             mapping: 'StartTime'
           },
         ]
        },
        {
          fields: [
            {
             type: 'multiple-choice',
             size: 'Medium',
             label: 'Event End Time:*',
             options: [
               { label: '7:30 AM', value: '07:30:00' },
               { label: '8:00 AM', value: '08:00:00' },
               { label: '8:30 AM', value: '08:30:00' },
               { label: '9:00 AM', value: '09:00:00' },
               { label: '9:30 AM', value: '09:30:00' },
               { label: '10:00 AM', value: '10:00:00' },
               { label: '10:30 AM', value: '10:30:00' },
               { label: '11:00 AM', value: '11:00:00' },
               { label: '11:30 AM', value: '11:30:00' },
               { label: '12:00 PM', value: '12:00:00' },
               { label: '12:30 PM', value: '12:30:00' },
               { label: '1:00 PM', value: '13:00:00' },
               { label: '1:30 PM', value: '13:30:00' },
               { label: '2:00 PM', value: '14:00:00' },
               { label: '2:30 PM', value: '14:30:00' },
               { label: '3:00 PM', value: '15:00:00' },
               { label: '3:30 PM', value: '15:30:00' },
               { label: '4:00 PM', value: '16:00:00' },
               { label: '4:30 PM', value: '16:30:00' },
               { label: '5:00 PM', value: '17:00:00' },
               { label: '5:30 PM', value: '17:30:00' },
               { label: '6:00 PM', value: '18:00:00' },
               { label: '6:30 PM', value: '18:30:00' },
               { label: '7:00 PM', value: '19:00:00' },
               { label: '7:30 PM', value: '19:30:00' },
               { label: '8:00 PM', value: '20:00:00' },
               { label: '8:30 PM', value: '20:30:00' },
               { label: '9:00 PM', value: '21:00:00' },
               { label: '9:30 PM', value: '21:30:00' },
               { label: '10:00 PM', value: '22:00:00' },
               { label: '10:30 PM', value: '22:30:00' },
               { label: '11:00 PM', value: '23:00:00' },
               { label: '11:30 PM', value: '23:30:00' },
               { label: '12:00 AM (next day)', value: '00:00:00' },
               { label: '12:30 AM (next day)', value: '00:30:00' },
               { label: '1:00 AM (next day)', value: '01:00:00' },
               { label: '1:30 AM (next day)', value: '01:30:00' },
               { label: '2:00 AM (next day)', value: '02:00:00' },
               { label: '2:30 AM (next day)', value: '02:30:00' }
             ],
             mapping: 'EndTime'
           }
         ]
       },
       {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Number of Guests:*',
            mapping: 'plannedguestcount'
          },
        ]
       },
       {
        fields: [
          {
          type: 'multiple-choice',
          size: 'Medium',
          label: 'Type of Event:*',
          options: [
            { label: 'Catering', value: 'Catering' },
            { label: 'On-Site Event', value: 'On-Site Event' },
          ],
          mapping: 'theme'
        },
      ]
     },
     {
      fields: [
        {
            type: 'text',
            size: 'Medium',
            label: 'First Name:*',
            mapping: 'firstName'
          },
        ]
       },
       {
        fields: [
          {
           type: 'text',
           size: 'Medium',
           label: 'Last Name:*',
           mapping: 'lastName'
         }
       ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email Address:*',
            mapping: 'email'
          },
        ]
       },
      {
        fields: [
         {
           type: 'text',
           size: 'Medium',
           label: 'Phone Number:*',
           mapping: 'telnumber'
          },
        ]
       },
       {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'How did you hear about us?:',
            mapping: 'Reference'
          }
        ]
      },
       {
        fields: [
          {
                type: 'text-area',
                size: 'XLarge',
                label: 'Any Additional Details About Your Event?:',
                mapping: 'notes'
              },
            ]
           },
           {
            fields: [
              {
            type: 'submit',
            size: 'Medium',
            label: 'SUBMIT'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Georgetown Due South Contact Form',
    formId: '1890',
    clientKey: 'E8BFFA12-9124-43C2-86EF-9FD3306B3694',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you for your inquiry. We will reach out shortly.  Please note that messages received after 5:00pm Friday "may" not receive a response until Monday morning.',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;
